import types from '../types'
import Action from '../../types/Action'

const initialState = {
  all: {
    loading: true,
    data: [],
    error: false,
    success: false
  },
  backgroundCheckVerification: {
    loading: false,
    success: false,
    error: false,
    data: { employee: [] }
  },
  updateBackgroundCheckVerification: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  serviceVerificationAudit: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  updateServiceVerificationAudit: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
}

const BackgroundCheckVerificationReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_PROVIDER_AUDITS_AND_VERIFICATIONS_REQUESTED: {
      return {
        ...state,
        all: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.GET_PROVIDER_AUDITS_AND_VERIFICATIONS_FULFILLED: {
      return {
        ...state,
        all: {
          ...state.all,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_PROVIDER_AUDITS_AND_VERIFICATIONS_REJECTED: {
      return {
        ...state,
        all: {
          ...state.all,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_REQUESTED: {
      return {
        ...state,
        backgroundCheckVerification: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_FULFILLED: {
      return {
        ...state,
        backgroundCheckVerification: {
          ...state.backgroundCheckVerification,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_BACKGROUND_CHECK_VERIFICATION_BY_ID_REJECTED: {
      return {
        ...state,
        backgroundCheckVerification: {
          ...state.backgroundCheckVerification,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_BACKGROUND_CHECK_VERIFICATION_REQUESTED: {
      return {
        ...state,
        updateBackgroundCheckVerification: {
          ...state.updateBackgroundCheckVerification,
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_BACKGROUND_CHECK_VERIFICATION_FULFILLED: {
      const index = state.all.data.findIndex((backgroundCheck) => backgroundCheck.id === action.payload.backgroundCheckVerification.id && backgroundCheck.type === 'Background Check')
      const updatedBackgroundCheckVerificationState = action.payload.mailSent.specialist && action.payload.mailSent.provider ? {
        success: true,
        data: action.payload
      } : {
        error: { response: { text: `<div style=\'font-size: 16px\'>This background check verification has been updated but the ${!action.payload.mailSent.specialist ? (!action.payload.mailSent.provider ? 'auditor and provider' : 'auditor') : ( !action.payload.mailSent.provider ? 'provider' : '' ) } could not be notified.</div>` } } // eslint-disable-line no-useless-escape
      }
      return {
        ...state,
        updateBackgroundCheckVerification: {
          ...state.updateBackgroundCheckVerification,
          ...updatedBackgroundCheckVerificationState,
          loading: false,
        },
        all: {
          ...state.all,
          data: [
            ...state.all.data.slice(0, index),
            action.payload.backgroundCheckVerification,
            ...state.all.data.slice(index + 1)
          ]
        }
      }
    }
    case types.UPDATE_BACKGROUND_CHECK_VERIFICATION_REJECTED: {
      return {
        ...state,
        updateBackgroundCheckVerification: {
          ...state.updateBackgroundCheckVerification,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPLOADED_BACKGROUND_CHECK_VERIFICATION_ATTACHMENT: {
      const { backgroundCheckVerificationEmployeeId, fileLocation, backgroundCheckVerificationEmployeeAttachmentId } = action.payload
      if (state.backgroundCheckVerification) {
        return {
          ...state,
          backgroundCheckVerification: {
            ...state.backgroundCheckVerification,
            data: {
              ...state.backgroundCheckVerification.data,
              employee: state.backgroundCheckVerification.data.employee.map((employeeItem) => 
                employeeItem.backgroundCheckVerificationEmployeeId == backgroundCheckVerificationEmployeeId
                  ? {
                    ...employeeItem,
                    attachment: [...employeeItem.attachment, { backgroundCheckVerificationEmployeeAttachmentId: backgroundCheckVerificationEmployeeAttachmentId, fileLocation }]
                  }
                  : employeeItem
              ),
            }
          },
        }
      }
    }
    case types.GET_SERVICE_VERIFICATION_AUDIT_BY_ID_REQUESTED: {
      return {
        ...state,
        serviceVerificationAudit: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.GET_SERVICE_VERIFICATION_AUDIT_BY_ID_FULFILLED: {
      return {
        ...state,
        serviceVerificationAudit: {
          ...state.serviceVerificationAudit,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_SERVICE_VERIFICATION_AUDIT_BY_ID_REJECTED: {
      return {
        ...state,
        serviceVerificationAudit: {
          ...state.serviceVerificationAudit,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_SERVICE_VERIFICATION_AUDIT_REQUESTED: {
      return {
        ...state,
        updateServiceVerificationAudit: {
          ...state.updateServiceVerificationAudit,
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_SERVICE_VERIFICATION_AUDIT_FULFILLED: {
      const index = state.all.data.findIndex((serviceVerification) => serviceVerification.id === action.payload.serviceVerificationAudit.id && serviceVerification.type === 'Service Verification')
      const updatedBackgroundCheckVerificationState = action.payload.mailSent.specialist ? {
        success: true,
        data: action.payload
      } : {
        error: { response: { text: '<div style=\'font-size: 16px\'>This service verification audit has been updated but the auditor could not be notified.</div>' } } // eslint-disable-line no-useless-escape
      }
      return {
        ...state,
        updateServiceVerificationAudit: {
          ...state.updateServiceVerificationAudit,
          ...updatedBackgroundCheckVerificationState,
          loading: false,
        },
        all: {
          ...state.all,
          data: [
            ...state.all.data.slice(0, index),
            action.payload.serviceVerificationAudit,
            ...state.all.data.slice(index + 1)
          ]
        }
      }
    }
    case types.UPDATE_SERVICE_VERIFICATION_AUDIT_REJECTED: {
      return {
        ...state,
        updateServiceVerificationAudit: {
          ...state.updateServiceVerificationAudit,
          loading: false,
          error: action.payload
        }
      }
    }
    default:
      return state
  }
}

export default BackgroundCheckVerificationReducer